import React, { FC } from 'react';
import Image from 'next/image';
import { styled } from 'linaria/react';
import { SteamAccountVoucher } from '@entities/tsp';
import { withTheme, useTheme } from '@shared/lib/theme';
import { Text } from '@shared/ui/atoms';
import steamVoucherCardBg from '../assets/steam-voucher-card.webp';
interface SteamVoucherCardProps {
  voucher: SteamAccountVoucher;
  countryUrl: string;
  fullWidth?: boolean;
}
const SteamVoucherCard: FC<SteamVoucherCardProps> = ({
  voucher,
  countryUrl,
  fullWidth = false
}) => {
  const {
    theme
  } = useTheme();
  const country = voucher.features?.country_web as string;
  const denomination = voucher.features?.buttonLabel as string;
  return <SteamVoucherCardWrapper fullWidth={fullWidth}>
      <ImageWrapper>
        <Image src={countryUrl} alt={country} width={32} height={32} />
      </ImageWrapper>
      <TextWrapper>
        <Text family="MTSWide" weight="bold" size={{
        desktop: 'h4',
        mobile: 'pL'
      }} color={theme.colors.constant.white}>
          {denomination}
        </Text>
      </TextWrapper>
    </SteamVoucherCardWrapper>;
};
export default SteamVoucherCard;
interface SteamVoucherCardWrapperProps {
  fullWidth: boolean;
}
const _exp = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '100%' : '13.125rem';
const _exp2 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? 'auto' : '19.6875rem';
const _exp4 = /*#__PURE__*/() => () => `url(${steamVoucherCardBg})`;
const _exp6 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.primary;
const _exp7 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? 'auto' : '232px';
const _exp8 = /*#__PURE__*/() => ({
  fullWidth
}) => fullWidth ? '2 / 3' : 'auto';
const SteamVoucherCardWrapper = withTheme(/*#__PURE__*/styled('div')({
  name: "SteamVoucherCardWrapper",
  class: "s1dgclfs",
  propsAsIs: false,
  vars: {
    "s1dgclfs-0": [_exp()],
    "s1dgclfs-1": [_exp2()],
    "s1dgclfs-2": [_exp8()],
    "s1dgclfs-3": [_exp4()],
    "s1dgclfs-4": [_exp6()],
    "s1dgclfs-5": [_exp7()]
  }
}));
const ImageWrapper = /*#__PURE__*/styled('div')({
  name: "ImageWrapper",
  class: "ixu2lzo",
  propsAsIs: false
});
const TextWrapper = /*#__PURE__*/styled('div')({
  name: "TextWrapper",
  class: "t19iyq57",
  propsAsIs: false
});

require("./SteamVoucherCard.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SteamVoucherCard.tsx");